import $ from 'jquery';

export default function SpecialDay(vm) {
    this.all = function(params) {
        var url = '/special-day/list?' + $.param(params);

        return vm.get(url);
    };

    this.create = function(params) {
        var url = '/special-day/create';

        return vm.post(url, params);
    };

    this.get = function(id) {
        var url = '/special-day/detail/' + id;

        return vm.get(url);
    };

    this.delete = function(params) {
        var url = null;

        if (params.is_permanent == 1)
            url = '/special-day/force-delete/' + params.id;
        else
            url = '/special-day/delete/' + params.id;

        return vm.delete(url);
    };

    this.restore = function(id) {
        var url = '/special-day/restore/' + id;

        return vm.get(url);
    };
}